<template>
  <div> 
    <div v-if="is_super_admin">
    <div>
      <el-button type="primary" icon="el-icon-plus" style="margin-block: 16px; margin-left: 16px;"
      size="mini" plain
      @click="add_activity"
      >新建活动</el-button>
    </div>

    <div>
      <el-alert
        title="提示"
        style="height:50px"
        type="warning"
        description="活动名称不可重复,不可修改,如需修改某活动名,开启后的活动不建议强制删除或修改"
        show-icon
        close-text="我知道了"
        >
      </el-alert>
    </div>

    <div style="margin-top: 20px">
      <el-table
        :data="l_activity_table_data"
        style="width: 100%;margin-bottom: 20px;"
        :header-cell-style="{'background-color': '#eff3f8', color: '#606266'}"
        default-expand-all
        border
        >

       
        <el-table-column
          prop="activity_name"
          label="活动名称"
          align="center"
          >
        </el-table-column>

        <el-table-column
          prop="activity_status"
          label="活动状态"
          align="center"
          >
          <template slot-scope="scope">
            <el-tag type="success" v-if="scope.row.activity_status == 1">开启</el-tag>
            <el-tag v-if="scope.row.activity_status == 0">关闭</el-tag>
            <!-- <el-tag v-else>关闭</el-tag> -->
          </template>
        </el-table-column>

        <el-table-column
          prop="coupon_num"
          label="优惠券数量"
          align="center"
          >
        </el-table-column>

        <!-- <el-table-column
          prop="activity_start_time"
          label="活动开始时间"
          align="center"
          >
          
        </el-table-column>

        <el-table-column
          prop="activity_end_time"
          label="活动结束时间"
          align="center"
          >
        </el-table-column> -->

        <el-table-column
          prop="activity_coupon_valid_days"
          label="优惠券有效天数"
          align="center"
          >
        </el-table-column>

        <el-table-column
          align="center"
          label="操作"
          >
          <template slot-scope="scope">
            <el-button plain round icon="el-icon-edit" type="success" size="small" @click="on_edit_activity(scope.row)">编辑</el-button>
            <el-button round icon="el-icon-delete" type="danger" size="small" @click="on_delete_activity(scope.row)">删除</el-button>
          </template>
        </el-table-column>

      </el-table>
    </div>

    <el-dialog :visible.sync="b_show_dialog" :fullscreen="b_show_fullscreen" :before-close="this.$dialog_close" :show-close="false" style="padding: 12px 16px;">
      <div slot="title" class="dialog-title">
        <span style="font-size: 18px; line-height: 24px; color: #303133;">{{ s_dialog_name }}</span>
        <el-button icon="el-icon-close" class='dialog-title-button' @click="cancel_func"></el-button>
        <el-button icon="el-icon-full-screen" class='dialog-title-button' @click="b_show_fullscreen = !b_show_fullscreen"></el-button>
      </div>

      <el-row :gutter="15">
        <el-form :model="d_form" ref="d_form" label-width="100px" @class="demo-d_form">
          
          <el-col :span="24">
            <el-form-item label="活动名称" prop="activity_name">
              <el-input v-model="d_form.activity_name" ></el-input>
            </el-form-item>
          </el-col>

          <!-- <el-col :span="24">
            <el-form-item label="时间区间" prop="l_activity_time">
              <el-date-picker
                v-model="d_form.l_activity_time"
                type="daterange"
                start-placeholder="活动开始日期"
                end-placeholder="活动结束日期"
                
                >
              </el-date-picker>
            </el-form-item>
          </el-col> -->

          <el-col :span="8">
            <el-form-item label="活动状态:" prop="activity_status">
              <!-- <el-input v-model="d_form.activity_status" ></el-input> -->
              <span v-if="d_form.activity_status == 1">开启 </span>
              <span v-if="d_form.activity_status == 0">关闭 </span>
              <el-switch
                v-model="d_form.activity_status"
                active-color="#13ce66"
                inactive-color="#ff4949"
                >
              </el-switch>
              
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="是否首页弹出:" prop="activity_is_popup">
              <!-- <el-input v-model="d_form.activity_status" ></el-input> -->
              <!-- <span v-if="d_form.is_pop_up == 1">弹出 </span>
              <span v-if="d_form.is_pop_up == 0">不弹出 </span> -->
              <el-switch
                v-model="d_form.activity_is_popup"
                active-color="#13ce66"
                inactive-color="#ff4949"
                >
              </el-switch>
              
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="邀请人数阈值" prop="activity_invitees_num">
              <el-input-number v-model="d_form.activity_invitees_num" :step="5"></el-input-number>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="活动描述" prop="activity_desc">
              <el-input v-model="d_form.activity_desc" type="textarea" ></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-divider><i class="el-icon-s-ticket"> 活动优惠券配置</i></el-divider>
          </el-col>

          <el-col :span="8">
            <el-form-item label="选择优惠券" prop="coupon_type_id">
              
              <el-select  v-model="d_form.coupon_type_id" placeholder="请选择优惠券" @change="coupon_type_change(d_form)">
                <el-option
                  v-for="item in l_coupon_type"
                  :key="item.coupon_type_id"
                  :label="item.coupon_name"
                  :value="item.coupon_type_id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="派发数量" prop="coupon_num">
              <el-input-number v-model="d_form.coupon_num" :step="5"></el-input-number>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="有效天数" prop="activity_coupon_valid_days">
              <el-input-number v-model="d_form.activity_coupon_valid_days" :step="5"></el-input-number>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="抵扣方式" prop="coupon_mode">
              <el-tag type="success" v-if="d_form.coupon_mode == 1">现金抵扣</el-tag>
              <el-tag v-if="d_form.coupon_mode == 2">折扣</el-tag>
              <el-tag type="warning" v-if="d_form.coupon_mode == 0">请选择先选择优惠券</el-tag>
              
            </el-form-item>
          </el-col>

          <el-col :span="12" v-if="d_form.coupon_mode == 1">
            <el-form-item label="抵扣金额" prop="coupon_amount">
              <el-tag type="success" v-model="d_form.coupon_amount">{{d_form.coupon_amount}}</el-tag>
            </el-form-item>
          </el-col>

          <el-col :span="12" v-if="d_form.coupon_mode == 2">
            <el-form-item label="折扣率" prop="coupon_discount">
              <el-tag v-model="d_form.coupon_discount">{{d_form.coupon_discount}}</el-tag>
            </el-form-item>
          </el-col>

          <el-col :span="12" v-if="d_form.coupon_mode == 0">
            <el-form-item label="未选择" prop="coupon_discount">
              <el-tag type="warning">请选择先选择优惠券</el-tag>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-divider><i class="el-icon-upload"> 上传图片</i></el-divider>
          </el-col>

          <el-col :span="12">
            <el-form-item label="活动背景图" prop="activity_background_img">
              <!-- <el-input v-model="d_form.activity_background_img" ></el-input> -->
              <el-upload
               action=""
               list-type="picture-card"
               :limit="1"
               :file-list="activity_background_img_list"
               :http-request="upload_activity_background_img"
               :before-remove="before_remove_activity_background_img"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
              
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="活动弹出图" prop="activity_popup_img">
              <!-- <el-input v-model="d_form.activity_popup_img" ></el-input> -->
              <el-upload
                action=""
                list-type="picture-card"
                :limit="1"
                :file-list="activity_popup_img_list"
                :http-request="upload_activity_popup_img"
                :before-remove="before_remove_activity_popup_img"
              >
                <i class="el-icon-plus"></i>
              </el-upload>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item>
              <el-button type="primary" @click="submit_form()" :disabled="b_disabled">{{ s_btn_name }}</el-button>
              <el-button @click="cancel_func">取消</el-button>
            </el-form-item>
          </el-col>
          
        </el-form>
      </el-row>
    </el-dialog>

    </div>

    <div v-else>
      <div style="text-align: center;">
        <div style="margin-top: 0px;">
          <img src="../../assets/permission_denied.png">
          <div style="margin-top: 20px;">
            <span style="font-size: 18px; line-height: 24px; color: #303133;">您没有权限访问该页面</span>
          </div>
        </div>
      </div>
    </div>

  </div>
  
</template>

<script>

export default {
  // 活动管理
  name: "ActivitySystem",
  data() {
    return {
      l_activity_table_data: [],

      l_coupon_type: [],

      activity_background_img_list: [],
      activity_popup_img_list: [],

      b_disabled: false,
      b_show_dialog: false,
      i_diaglog_type: 1,
      b_show_fullscreen: false,
      s_dialog_name: '',
      s_btn_name: '',
      d_form: {
        coupon_mode: 0,
      },
      is_super_admin: false,
    };
  },

  mounted(){
    // 判断当前用户是否是超级管理员, 如果不是超级管理员, 页面提示无权限操作
    let isSuperAdmin = window.sessionStorage.getItem("is_super_admin")
    if (isSuperAdmin == "false") {
      this.is_super_admin = false
      return
    } else {
      this.is_super_admin = true
    }
    this.ref_activity_table_data()
  },
  
  methods: {
    
    // 刷新活动列表
    async ref_activity_table_data(){
      let res = await this.$axios.get('/api/activity/');
      this.l_activity_table_data = res.data
    },

    // 新建活动 
    async add_activity(){
       // 获取当前优惠券类型
      await this.get_coupon_type()
      // console.log(this.l_coupon_type)

      // 重置表单数据
      this.d_form = {
        coupon_mode: 0,
        activity_status: false,
        activity_is_popup: false,
      }

      this.activity_background_img_list = []
      this.activity_popup_img_list = []
      
      this.i_diaglog_type = 1
      this.b_show_dialog = true;
      this.s_dialog_name = '新建活动';
      this.s_btn_name = '新建';

    },

    // 编辑活动
    async on_edit_activity(row){
      // 获取当前优惠券类型
      await this.get_coupon_type()

      this.d_form = JSON.parse(JSON.stringify(row))

      this.coupon_type_change(this.d_form)

      this.activity_background_img_list = [{url: row.activity_background_img}]
      this.activity_popup_img_list = [{url: row.activity_popup_img}]

      // this.d_form.l_activity_time = [row.activity_start_time, row.activity_end_time]

      this.b_show_dialog = true;
      this.s_dialog_name = '编辑活动';
      this.s_btn_name = '保存';
      this.i_diaglog_type = 2

    },

     // 删除活动类型
    on_delete_activity(row){
      this.$confirm('此操作将永久删除该优惠券类型, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.on_delete_submit(row)
       
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });          
      });
    },


    // 执行删除请求
    async on_delete_submit(row){
      let res = await this.$axios.delete('/api/activity/' + row.activity_id + '/')
      console.log(res)
      if (res.status === 204){
        this.ref_activity_table_data()
        this.$message({
          type: 'success',
          message: '删除成功!'
        });
      }else {
        this.$message({
          type: 'error',
          message: '删除失败!请检查是否已有其他关联或使用'
        });
      }
    },

    // 提交表单事件
    async submit_form(){
      console.log(111)
      console.log(this.d_form)

      // // 处理时间数据
      // this.d_form.activity_start_time = this.d_form.l_activity_time[0]
      // this.d_form.activity_end_time = this.d_form.l_activity_time[1]

      if (this.i_diaglog_type === 1){
        
        // // 获取提交表单需要的数据
        // let d_new_data = this.get_submit_data()
        
        // 提交表单
        let res = await this.$axios.post('/api/activity/', this.d_form)
        this.request_waring(res)
      }
      else if (this.i_diaglog_type === 2){
        // 获取提交表单需要的数据
        // let d_new_data = this.get_submit_data()
        
        // console.log(d_new_data)
        // 提交表单 
        let res = await this.$axios.put('/api/activity/' + this.d_form.activity_id + '/', this.d_form)
        console.log(res)

        this.request_waring(res)
      }
      
    },

    // 请求警告
    request_waring(res){
      if (res.status === 201 || res.status === 200){
        this.$message({
          message: '保存成功',
          type: 'success'
        })
        this.b_show_dialog = false
        this.ref_activity_table_data()
        
      } else {
        this.$message({
          message: '保存失败',
          type: 'error'
        })
      }
      // 重置数据
      this.reset_data()
    },

    // 重置数据
    reset_data(){
      this.d_form = {
        coupon_mode: 0,
      }
      this.activity_background_img_list = []
      this.activity_popup_img_list = []
    },

    // 获取提交表单需要的数据
    get_submit_data(){
      let d_new_data = {}
      d_new_data.activity_name = this.d_form.activity_name
      d_new_data.activity_background_img = this.d_form.activity_background_img
      d_new_data.activity_popup_img = this.d_form.activity_popup_img
      // d_new_data.activity_start_time = this.d_form.activity_start_time
      // d_new_data.activity_end_time = this.d_form.activity_end_time
      d_new_data.coupon_type_id = this.d_form.coupon_type_id
      d_new_data.coupon_num = this.d_form.coupon_num
      d_new_data.activity_coupon_valid_days = this.d_form.activity_coupon_valid_days
      d_new_data.activity_status = this.d_form.activity_status
      d_new_data.activity_desc = this.d_form.activity_desc
      d_new_data.activity_desc = this.d_form.activity_desc
      d_new_data.activity_desc = this.d_form.activity_desc

      return d_new_data
    },

    // 取消事件
    cancel_func(){
      this.b_show_dialog = false;
      this.reset_data()
    },

    // 优惠券变更绑定事件
    coupon_type_change(d_data){
      console.log(d_data)
      // 遍历优惠券类型 查找对应id信息
      for(let i = 0; i < this.l_coupon_type.length; i++){
        if(this.l_coupon_type[i].coupon_type_id == d_data.coupon_type_id){
          d_data.coupon_mode = this.l_coupon_type[i].coupon_mode;
          d_data.coupon_amount = this.l_coupon_type[i].coupon_amount;
          d_data.coupon_discount = this.l_coupon_type[i].coupon_discount;
        }
      }
      
    },

    // 获取当前优惠券类型
    async get_coupon_type(){
      let res = await this.$axios.get('/api/coupon_type/')
      if (res.status === 200) {
        console.log(this.l_coupon_type)
        this.l_coupon_type = res.data
      }else{
        this.$message.error(res.data.msg)
      }
    },

    // 上传活动背景图
    async upload_activity_background_img(option){
      let res = await this.$upload_common(option, 'activity_background_img')
      console.log(res)
      this.d_form.activity_background_img = res.data.s_url
      console.log(this.d_form)
    },

    // 删除文件接口
    async before_remove_activity_background_img(){
      let s_remove_url = this.d_form.activity_background_img
      await this.$remove_common(s_remove_url)
      this.d_form.activity_background_img = ''
    },

    // 上传活动弹出图
    async upload_activity_popup_img(option){
      let res = await this.$upload_common(option, 'activity_popup_img')
      console.log(res)
      this.d_form.activity_popup_img = res.data.s_url
      console.log(this.d_form)
    },

    // 删除文件接口
    async before_remove_activity_popup_img(){
      let s_remove_url = this.d_form.activity_popup_img
      await this.$remove_common(s_remove_url)
      this.d_form.activity_popup_img = ''
    },
  },
  
  
};
</script>


